<section>
    <div class="registration_vertor">
        <div>
            <img src="../../../../assets/image/registration-blue.svg" class="registration-blue" alt="blue">
            <div>
                <img src="../../../../assets/image/registration-yellow.svg" class="registration-yellow" alt="yellow">
            </div>
        </div>
        <div>
            <img src="../../../../assets/image/srilogo 2@2x.png" alt="">
            <p class="signup">Sign Up</p>
        </div>
        <div>
            <img src="../../../../assets/image/reg-blue.png" alt="" class="reg_blue">
        </div>
    </div>
    <div>
        <p class="registration_title">Registration</p>
    </div>
</section>
<section>
    <form class="registor_horizontal">
            <div class="col-md-8">
                <div class="form-group">
                    <input type="email" class="form-control" id="inputEmail3" placeholder="Admission number"
                        formControlName="admissionNumber" maxlength="9">
                    <i class="fa fa-user"></i>

                </div>
            </div>
    </form>
</section>